export function assetDimensions(asset) {
	// console.log(" ");
	// console.log("^^^");
	// console.log("get asset dimensions");
	const source = asset.src;
	const tag = asset.tagName.toLowerCase();

	const assetClone = document.createElement(tag);
	assetClone.src = source;
	assetClone.tag = tag;
	if (tag == "video") {
		// console.log("asset.videoWidth: ", asset.videoWidth)
		// console.log("asset.videoHeight: ", asset.videoHeight)
		assetClone.width = asset.videoWidth;
		assetClone.height = asset.videoHeight;
		assetClone.ratio = asset.videoHeight / asset.videoWidth;
		// console.log("processed vid", asset);
	} else {
		assetClone.ratio = assetClone.height / assetClone.width;
		// console.log("processed img", asset);
	}

	// console.log("📤 Sending... w: " + assetClone.width + " h: " + assetClone.height + " r: " + assetClone.ratio + " t: " + assetClone.tag);
	// console.log("vvv");
	// console.log(" ");

	return {width: assetClone.width, height: assetClone.height, ratio: assetClone.ratio, tag: assetClone.tag}
}


